/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";

export const useInitPayment = ({ invoice_id: invoiceId, ...params }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.initPayment({ invoice_id: invoiceId, ...params }),
    // values passed to mutate() at call time override the hook's params, e.g. a callback_url
    // that depends on whether the payment popup actually opened
    mutationFn: (variables) => fetcher({
      method: "GET",
      url: `/public/invoice/pay/id/${invoiceId}`,
      params: { ...params, ...variables },
    }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.invoice.detail(invoiceId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.invoices.all });
    },
  });
};
